import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { OrderTransaction } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to get orderTransaction data
 */
@Injectable()
export class OrderTransactionService {
    public static INCLUDE_TRANSACTION_ITEMS: string = 'orderTransactionItems';

    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all order transactions for the specified order
     */
    public getIndex(orderId: string, includes: string[] = null): Observable<OrderTransaction[]> {
        const queryParams: string[] = ['page[size]=500'];
        const apiRequestUrl: string = this.getApiUrl(orderId, includes, queryParams);

        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const json: any = response;
                return json.data.map((ot: any) => (new OrderTransaction()).deserialize(ot, json.included));
            }));
    }

    /**
     * Refund the order transaction
     */
    public refund(
        orderId: string,
        orderTransactionId: string,
        refundAmount: number,
        withholdAmount: number,
        orderTransactionItemIds: string[],
    ): Observable<OrderTransaction> {
        const apiRequestUrl: string = `${this.getApiUrl(orderId)}${orderTransactionId}/refund`;
        const body: any = {
            refundAmount: refundAmount,
            withholdAmount: withholdAmount,
            orderTransactionItemIds: orderTransactionItemIds,
        };

        return this.http.post(apiRequestUrl, body)
            .pipe(map((response: IJsonApiResponse) => (new OrderTransaction()).deserialize(response)));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(orderId: string, includes?: string[], queryParams?: string[]): string {
        let url: string = `${this.http.configService.getApiBaseUrl()}/orders/${orderId}/order-transactions/`;
        url += this.http.getQueryParameters(includes, queryParams);
        return url;
    }
}
